import React, { useEffect, useState } from "react";
import Navbar from "./components/navbar";
import Filter from "./components/filter";
import Header from "./components/header";
import TabContent from "./components/content";
import { connect, useSelector } from "react-redux";
import Pagination from "../shared/components/Button/Pagination";
import { getAudiences } from "../../store/action/audiencesAction";

const _ = require("lodash");
const Customer = (props) => {
  const PAGE = {
    CUSTOMER: "customer",
    CUSTOMERGROUP: "customerGroup",
  };


  const { page, getAudiences } = props;
  // const dispatch = useDispatch();
  // const page = useSelector((state) => state.page);
  const [currentPage, setCurrentPage] = useState(PAGE.CUSTOMER);
  const [searchName, setSearchName] = useState("");
  const total = useSelector((state) => state.audiences.data.total);


  useEffect(() => {
    if (!_.isEmpty(page)) {
      getAudiences();
    }
  }, [page]);

  const changePage = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = (value) => {
    setSearchName(value);
  };

  const onChangePaginate = (pageNumber, pageSize) => {
    getAudiences(pageNumber, pageSize);
  };

  return (
    <div id="bot-scene-container">
      <div id="bot-scene-content" className="scroll-light">
        <Header currentPage={currentPage} />
        <div className="col-sm-12 p-none audience-screen app-v2-layout-content">
          <div className="col-sm-12 p-none">
            <div className="wrap-dynamic-tabs-audience-screen">
              <div className="dynamic-tabs-container">
                <Navbar
                  onPageChange={changePage}
                  currentPage={currentPage}
                  pageConstant={PAGE}
                />
                <div className="tabs-body-container">
                  <Filter
                    currentPage={currentPage}
                    pageConstant={PAGE}
                    onSearchNameChange={handleSearch}
                    searchName={searchName}
                  />
                  <TabContent currentPage={currentPage} pageConstant={PAGE} />

                  <div className="app-report-table--pagination">
                    <Pagination
                      onChange={onChangePaginate}
                      total={total}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { page } = state;
  return {
    page,
  };
};
export default connect(mapStateToProps, {
  getAudiences,
})(Customer);

